import palette from '../../../../theme/palette'

export const titleStyle = {
	fontSize: '16px',
	fontWeight: '600',
	lineHeight: '28px',
	textAlign: 'left',
	color: palette.text.darkBlue,
}

export const boxContainerStyle = {
	border: '1px solid ' + palette.sidebar.borderGray,
	borderRadius: '4px',
	padding: '16px',
}
